// extracted by mini-css-extract-plugin
module.exports = {"animated":"style_animated__31es5","falling":"style_falling__58p-P"};